// extracted by mini-css-extract-plugin
export var borderTop = "_o-3";
export var linkIcon = "_o-5";
export var linkIconSm = "_o-6";
export var linkOutCard = "_o-7 _o-4";
export var linkRow = "_o-2";
export var pageContainer = "_o-1";
export var providerIcon = "_o-8";
export var roundedBorder = "_o-4";
export var settingsContent = "_o-0";